<template>
  <div class="bg-white rounded-xl border border-gray-200 overflow-hidden" data-testid="teacher-profile-card">
    <div class="h-1.5 bg-primary"></div>
    <div class="p-3">
      <div class="flex flex-col md:flex-row md:items-start justify-between gap-2">
        <div class="flex items-start gap-3">
          <Avatar
            :label="initials"
            class="!bg-primary !text-white font-bold shrink-0"
            shape="circle"
            size="large"
          />
          <div>
            <h2 class="text-lg font-semibold text-gray-800" data-testid="teacher-name">{{ teacher.name }}</h2>
            <p class="text-gray-500 text-sm mt-0.5" data-testid="teacher-email">{{ teacher.email }}</p>

            <div class="flex flex-wrap items-center gap-1.5 mt-2">
              <Tag
                :value="teacher.status"
                :severity="teacher.status === 'active' ? 'success' : 'danger'"
                data-testid="teacher-status"
              />
              <span
                v-for="role in activeRoles"
                :key="role"
                class="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-primary/10 text-primary-700 border border-primary/20"
                data-testid="teacher-role-badge"
              >
                {{ role }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Staff } from '@/types/composition-functions';

const props = defineProps<{
  teacher: Staff;
}>();

const initials = computed(() =>
  props.teacher.name
    .split(' ')
    .map(n => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase(),
);

const activeRoles = computed(() => {
  if (!props.teacher.roles?.length) return [];
  const labels = props.teacher.roles
    .filter((r) => r?.is_active !== false)
    .map((r) => r.permissionGroup?.name || r.permission?.resource || r.category || null)
    .filter((v): v is string => !!v);
  return Array.from(new Set(labels));
});
</script>
